function getNextPost(postId, callback) {
  jQuery
    .ajax({
      method: "POST",
      url: ajaxData.ajaxUrl,
      data: {
        _ajax_nonce: ajaxData.ajaxNonce,
        action: "gcmis_load_next_post",
        postId,
      },
    })
    .done(function (msg) {
      callback(msg);
    });
}

export default getNextPost;
